/** Static in-house drivers for assign-driver modal (display preview only). */
export const STATIC_DELIVERY_DRIVERS = [
  {
    id: 'drv-1',
    firstName: 'James',
    lastName: 'Wilson',
    phone: '(312) 555-0142',
    email: 'j.wilson@example.com',
    status: 'available',
    activeOrders: 0,
    vehicle: 'Car',
  },
  {
    id: 'drv-2',
    firstName: 'Maria',
    lastName: 'Garcia',
    phone: '(773) 555-0198',
    email: 'm.garcia@example.com',
    status: 'available',
    activeOrders: 1,
    vehicle: 'Bike',
  },
  {
    id: 'drv-3',
    firstName: 'David',
    lastName: 'Chen',
    phone: '(847) 555-0163',
    email: 'd.chen@example.com',
    status: 'on_delivery',
    activeOrders: 2,
    vehicle: 'Car',
  },
  {
    id: 'drv-4',
    firstName: 'Aisha',
    lastName: 'Patel',
    phone: '(630) 555-0177',
    email: 'a.patel@example.com',
    status: 'available',
    activeOrders: 0,
    vehicle: 'Scooter',
  },
  {
    id: 'drv-5',
    firstName: 'Marcus',
    lastName: 'Johnson',
    phone: '(708) 555-0129',
    email: 'm.johnson@example.com',
    status: 'offline',
    activeOrders: 0,
    vehicle: 'Car',
  },
];

export function getDriverDisplayName(driver) {
  return `${driver?.firstName ?? ''} ${driver?.lastName ?? ''}`.trim() || '—';
}

export function getDriverStatusLabel(status) {
  const map = {
    available: 'Available',
    on_delivery: 'On delivery',
    offline: 'Offline',
  };
  return map[status] ?? status;
}
